<ng-container *ngIf="accountFunction; else selectMailToRead">
  <!-- Header -->
  <div class="header">
    <!-- Toolbar -->
    <div class="toolbar">
      <div class="info">
        <!-- Subject -->
        <div class="subject">Method Name: {{ accountFunction.method_name }}</div>
      </div>

      <div class="mr-4"></div>
    </div>
  </div>

  <!-- Threads -->
  <div class="threads">
    <!-- Thread -->
    <div class="thread">
      <form [formGroup]="accountFunctionForm">
        <div class="row description">
          <mat-form-field class="treo-mat-textarea treo-mat-no-subscript">
            <textarea matInput treoAutogrow [formControlName]="'method_code'" [spellcheck]="false"></textarea>
          </mat-form-field>
        </div>
        <div class="reply-form-buttons mt-3 flex flex-auto justify-end">
          <!-- Actions -->
          <button mat-flat-button type="submit" class="mr-5" (click)="save()">Save</button>
          <!-- Actions -->
          <button mat-flat-button type="button" (click)="publish()">Publish</button>
        </div>
      </form>
    </div>
  </div>
</ng-container>

<!-- Select mail to read template -->
<ng-template #selectMailToRead>
  <div class="select-mail-to-read">
    <mat-icon [svgIcon]="'iconsmind:mailbox_empty'"></mat-icon>
    <h4>Select a mail to read</h4>
  </div>
</ng-template>
